import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import UserDashboard from './pages/UserDashboard';
import ProtectedRoute from './router/ProtectedRoute';
import MobileBottomNav from './components/MobileBottomNav';
import { AuthProvider } from './context/AuthContext';
// Removed: FeatureFlagProvider, useFeatureFlags
import './App.css';

const AppRoutes = () => {
  // Removed feature flag check logic

  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        {/* Removed: JobsPage, EventsPage, DealsPage routes */}

        {/* User Dashboard - Protected */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>

      {/* Persistent Bottom Navigation for Mobile */}
      <MobileBottomNav />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      {/* Removed FeatureFlagProvider */}
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <AppRoutes />
        </div>
      </Router>
      {/* End Removed FeatureFlagProvider */}
    </AuthProvider>
  );
}

export default App;